// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-item {
  max-width: min(250px, 100%);

  .versal-icon {
    max-width: 25%;
    align-self: flex-start;
    padding: 5px;
  }

  .description {
    height: 150px;
    text-align: left;
    font-size: smaller;
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/app-home/blocs/menu-item.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;;EAE3B;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".menu-item {\n  max-width: min(250px, 100%);\n\n  .versal-icon {\n    max-width: 25%;\n    align-self: flex-start;\n    padding: 5px;\n  }\n\n  .description {\n    height: 150px;\n    text-align: left;\n    font-size: smaller;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
